import { ref, onUnmounted } from "vue";

/**
 * Composable to track focus state of any given elements
 * and (optionally) their descendants.
 *
 * @param elementRefs - Array of refs (or a single ref) to elements to check
 * @param checkDescendants - If true, focus on any descendant counts as focused
 */
export function useFocusState(
    elementRefs: any[] | any,
    checkDescendants = true,
) {
    const focused = ref(false);
    const refs = Array.isArray(elementRefs) ? elementRefs : [elementRefs];

    const isFocusWithin = () => {
        const active = document.activeElement;
        const result = refs.some((refEl) => {
            const el = refEl.value;
            if (!el) return false;
            if (checkDescendants) {
                return (
                    el === active ||
                    (el instanceof Element && el.contains(active))
                );
            } else {
                return el === active;
            }
        });
        return result;
    };

    const handleFocus = () => {
        focused.value = true;
    };

    const handleBlur = () => {
        setTimeout(() => {
            focused.value = isFocusWithin();
        }, 0);
    };

    onUnmounted(() => {
        focused.value = false;
    });

    return {
        focused,
        handleFocus,
        handleBlur,
    };
}
